import { render, staticRenderFns } from "./query-refund.vue?vue&type=template&id=557c4360&scoped=true"
import script from "./query-refund.vue?vue&type=script&lang=js"
export * from "./query-refund.vue?vue&type=script&lang=js"
import style0 from "./query-refund.vue?vue&type=style&index=0&id=557c4360&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557c4360",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('557c4360')) {
      api.createRecord('557c4360', component.options)
    } else {
      api.reload('557c4360', component.options)
    }
    module.hot.accept("./query-refund.vue?vue&type=template&id=557c4360&scoped=true", function () {
      api.rerender('557c4360', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/customer-service/query-refund.vue"
export default component.exports